  /* ============================================================
     EDITOR DE SHOPIFY — bandera de modo editor
     ============================================================
     Debe ir primero. Cuando el tema se carga dentro del editor
     visual, Shopify.designMode === true. Marcamos <html> con la
     clase "pikeo-editor" para que el CSS (pikeo-landing.css) fuerce
     la visibilidad de los .reveal. ¿Por qué hace falta? Porque al
     editar un ajuste, el editor re-renderiza sólo la sección tocada
     dentro del iframe y NO vuelve a ejecutar este archivo; como los
     .reveal arrancan en opacity:0 y sólo se muestran cuando el
     IntersectionObserver (que corre una sola vez) les añade .in, las
     secciones re-renderizadas se quedaban invisibles hasta "Guardar".
     La clase persiste en <html> entre re-renderizaciones, así que el
     seguro CSS nunca caduca. (No afecta al sitio en vivo.) */
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('pikeo-editor');
  }

  /* ============================================================
     >>> EDITA AQUÍ TUS DATOS REALES <<<
     ============================================================ */
  /* Los enlaces se configuran desde la sección "Pikeo · Nav + WhatsApp" en el editor.
     Si no se definen ahí, se usan estos valores por defecto. */
  const _PK = (window.PIKEO || {});
  const CHECKOUT_URL  = _PK.CHECKOUT_URL  || "https://www.pikeo.cl/tienda";
  const WHATSAPP_URL  = _PK.WHATSAPP_URL  || "https://wa.me/56229148555?text=Hola%2C+Estoy+en+la+Web+y+quiero+m%C3%A1s+informaci%C3%B3n";
  const MAYORISTA_URL = _PK.MAYORISTA_URL || "https://www.pikeo.cl/mayoristas";

  document.querySelectorAll('[data-checkout]').forEach(a => { if (CHECKOUT_URL && CHECKOUT_URL !== "#") a.href = CHECKOUT_URL; });
  ['wa','waContact','waContact2'].forEach(id => { const el=document.getElementById(id); if(el) el.href = WHATSAPP_URL; });
  const ml = document.getElementById('mayoristaLink'); if (ml) ml.href = MAYORISTA_URL;

  const year = document.getElementById('year');
  if (year) year.textContent = new Date().getFullYear();

  /* Nav + progress */
  const nav = document.getElementById('nav');
  const progress = document.getElementById('progress');
  const heroVideo = document.getElementById('heroVideo');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobileViewport = () => window.matchMedia('(max-width: 767px)').matches;
  const responsiveAttr = (el, desktopAttr, mobileAttr, fallback = '') => {
    if (!el) return fallback;
    const desktopValue = el.getAttribute(desktopAttr);
    const mobileValue = mobileAttr ? el.getAttribute(mobileAttr) : '';
    return (isMobileViewport() ? (mobileValue || desktopValue) : desktopValue) || fallback;
  };
  if (reduceMotion && heroVideo) heroVideo.pause();

  const enableDragScroll = (el) => {
    if (!el) return;
    if (typeof el._pikeoDragCleanup === 'function') {
      el._pikeoDragCleanup();
    }
    const previousTouchAction = el.style.touchAction;
    el.style.touchAction = 'pan-x pan-y pinch-zoom';

    let down = false, axis = '', dragged = false, startX = 0, startY = 0, startLeft = 0;
    const end = (event) => {
      if (!down) return;
      down = false;
      axis = '';
      el.classList.remove('is-dragging');
      el.removeEventListener('pointermove', onPointerMove);
      if (event && el.releasePointerCapture) {
        try { el.releasePointerCapture(event.pointerId); } catch (_) {}
      }
      window.setTimeout(() => { dragged = false; }, 0);
    };
    const onPointerDown = (event) => {
      if (el.scrollWidth <= el.clientWidth + 2) return;
      if (event.pointerType !== 'mouse') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      down = true;
      axis = '';
      dragged = false;
      startX = event.clientX;
      startY = event.clientY;
      startLeft = el.scrollLeft;
      el.addEventListener('pointermove', onPointerMove, { passive:false });
    };
    const onPointerMove = (event) => {
      if (!down) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      const absX = Math.abs(dx);
      const absY = Math.abs(dy);

      if (!axis) {
        if (absX < 8 && absY < 8) return;
        if (absY > absX * 1.15) {
          end(event);
          return;
        }
        if (absX > absY * 1.15) {
          axis = 'x';
          if (el.setPointerCapture) {
            try { el.setPointerCapture(event.pointerId); } catch (_) {}
          }
        } else {
          return;
        }
      }

      if (axis !== 'x') return;
      if (!dragged && absX > 3) {
        dragged = true;
        el.classList.add('is-dragging');
      }
      el.scrollLeft = startLeft - dx;
      event.preventDefault();
    };
    const onPointerUp = (event) => end(event);
    const onPointerCancel = (event) => end(event);
    const onClickCapture = (event) => {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
    };
    el.addEventListener('pointerdown', onPointerDown);
    el.addEventListener('pointerup', onPointerUp);
    el.addEventListener('pointercancel', onPointerCancel);
    el.addEventListener('click', onClickCapture, true);
    el._pikeoDragCleanup = () => {
      el.removeEventListener('pointerdown', onPointerDown);
      el.removeEventListener('pointermove', onPointerMove);
      el.removeEventListener('pointerup', onPointerUp);
      el.removeEventListener('pointercancel', onPointerCancel);
      el.removeEventListener('click', onClickCapture, true);
      el.classList.remove('is-dragging');
      el.style.touchAction = previousTouchAction;
    };
  };
  const cleanupLoopingRail = (root, rail, readyFlag) => {
    if (typeof root?._pikeoCarouselCleanup === 'function') {
      root._pikeoCarouselCleanup();
    }
    if (rail) {
      rail.querySelectorAll('[data-loop-clone]').forEach((node) => node.remove());
      delete rail.dataset[readyFlag];
      rail.scrollLeft = 0;
    }
    delete root?._pikeoCarouselRefresh;
  };
  const setupLoopingRail = ({ root, rail, itemSelector, prevSelector, nextSelector, readyFlag }) => {
    if (!root || !rail || rail.dataset[readyFlag] === 'true') return;
    const originals = Array.from(rail.querySelectorAll(`${itemSelector}:not([data-loop-clone])`));
    if (originals.length < 2) return;
    rail.dataset[readyFlag] = 'true';

    originals.forEach((item, index) => {
      item.dataset.loopIndex = String(index);
    });
    const clone = (item) => {
      const copy = item.cloneNode(true);
      copy.dataset.loopIndex = item.dataset.loopIndex;
      copy.dataset.loopClone = 'true';
      copy.classList.remove('reveal', 'in', 'd1', 'd2', 'd3');
      copy.querySelectorAll('.reveal,.in,.d1,.d2,.d3').forEach((el) => el.classList.remove('reveal', 'in', 'd1', 'd2', 'd3'));
      return copy;
    };
    const before = originals.map(clone);
    const after = originals.map(clone);
    rail.prepend(...before);
    rail.append(...after);

    const prev = prevSelector ? root.querySelector(prevSelector) : null;
    const next = nextSelector ? root.querySelector(nextSelector) : null;
    let segment = 0;
    let ticking = false;
    let pointerDown = false;

    const measure = () => {
      const firstReal = originals[0];
      const firstAfter = after[0];
      segment = firstReal && firstAfter ? firstAfter.offsetLeft - firstReal.offsetLeft : 0;
    };
    const normalize = () => {
      if (!segment) return;
      while (rail.scrollLeft < segment * .45) rail.scrollLeft += segment;
      while (rail.scrollLeft > segment * 1.55) rail.scrollLeft -= segment;
    };
    const update = () => {
      ticking = false;
      if (!pointerDown) normalize();
    };
    const schedule = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    const centerRealSet = () => {
      measure();
      if (segment) rail.scrollLeft = segment;
    };
    const step = (direction) => {
      const card = originals[0];
      const styles = window.getComputedStyle(rail);
      const gap = parseFloat(styles.columnGap || styles.gap || 20) || 20;
      const distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.86;
      rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
      window.setTimeout(schedule, 320);
    };

    if (!isMobileViewport()) {
      enableDragScroll(rail);
    }
    const onPointerDown = () => { pointerDown = true; };
    rail.addEventListener('pointerdown', onPointerDown, { passive:true });
    const releasePointer = () => {
      pointerDown = false;
      schedule();
    };
    const onPointerUp = () => releasePointer();
    const onPointerCancel = () => releasePointer();
    const onLostPointerCapture = () => releasePointer();
    const onScroll = () => schedule();
    const onPrevClick = () => step(-1);
    const onNextClick = () => step(1);
    rail.addEventListener('pointerup', onPointerUp, { passive:true });
    rail.addEventListener('pointercancel', onPointerCancel, { passive:true });
    rail.addEventListener('lostpointercapture', onLostPointerCapture, { passive:true });
    rail.addEventListener('scroll', onScroll, { passive:true });
    if (prev) prev.addEventListener('click', onPrevClick);
    if (next) next.addEventListener('click', onNextClick);
    window.addEventListener('resize', centerRealSet, { passive:true });
    root._pikeoCarouselRefresh = () => {
      centerRealSet();
      schedule();
    };
    root._pikeoCarouselCleanup = () => {
      window.removeEventListener('resize', centerRealSet);
      rail.removeEventListener('pointerdown', onPointerDown);
      rail.removeEventListener('pointerup', onPointerUp);
      rail.removeEventListener('pointercancel', onPointerCancel);
      rail.removeEventListener('lostpointercapture', onLostPointerCapture);
      rail.removeEventListener('scroll', onScroll);
      if (prev) prev.removeEventListener('click', onPrevClick);
      if (next) next.removeEventListener('click', onNextClick);
      if (typeof rail._pikeoDragCleanup === 'function') {
        rail._pikeoDragCleanup();
      }
    };
    requestAnimationFrame(centerRealSet);
  };
  const setupFiniteRail = ({ root, rail, prev, next }) => {
    if (!root || !rail) return;
    if (typeof root._pikeoCarouselCleanup === 'function') {
      root._pikeoCarouselCleanup();
    }
    if (typeof rail._pikeoDragCleanup === 'function') {
      rail._pikeoDragCleanup();
    }
    if (!isMobileViewport()) {
      enableDragScroll(rail);
    }
    const measureStep = () => {
      const card = rail.querySelector(':scope > *');
      const styles = window.getComputedStyle(rail);
      const gap = parseFloat(styles.columnGap || styles.gap || 20) || 20;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.86;
    };
    const update = () => {
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      if (rail.scrollLeft > maxScroll) {
        rail.scrollLeft = maxScroll;
      }
      const hasOverflow = maxScroll > 12;
      root.classList.toggle('is-static', !hasOverflow);
      if (prev) prev.disabled = !hasOverflow || rail.scrollLeft <= 4;
      if (next) next.disabled = !hasOverflow || rail.scrollLeft >= maxScroll - 4;
    };
    const step = (direction) => {
      rail.scrollBy({ left: direction * measureStep(), behavior: 'smooth' });
      window.setTimeout(update, 340);
    };
    const onScroll = () => update();
    const onPrevClick = () => step(-1);
    const onNextClick = () => step(1);
    rail.addEventListener('scroll', onScroll, { passive:true });

    /* Brillo del botón de la card central al detenerse el swipe (móvil).
       Dispara una sola vez por frenada usando scrollend nativo con fallback
       a debounce por setTimeout (Firefox no soporta scrollend). */
    const nearestCenteredCard = () => {
      const cards = rail.querySelectorAll('.prod');
      if (!cards.length) return null;
      const center = rail.scrollLeft + rail.clientWidth / 2;
      let closest = cards[0];
      let distance = Infinity;
      cards.forEach((card) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const nextDistance = Math.abs(cardCenter - center);
        if (nextDistance < distance) {
          closest = card;
          distance = nextDistance;
        }
      });
      return closest;
    };
    let shineTimer = null;
    const triggerShine = () => {
      const card = nearestCenteredCard();
      const btn = card ? card.querySelector('.prod-btn') : null;
      if (!btn) return;
      rail.querySelectorAll('.prod-btn.is-shine').forEach((node) => node.classList.remove('is-shine'));
      btn.classList.add('is-shine');
      window.clearTimeout(shineTimer);
      shineTimer = window.setTimeout(() => btn.classList.remove('is-shine'), 720);
    };
    let scrollEndTimer = null;
    const onScrollForShine = () => {
      if (scrollEndTimer) window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(triggerShine, 150);
    };
    rail.addEventListener('scroll', onScrollForShine, { passive:true });
    const supportsScrollEnd = 'onscrollend' in window;
    if (supportsScrollEnd) {
      rail.addEventListener('scrollend', triggerShine, { passive:true });
    }

    if (prev) prev.addEventListener('click', onPrevClick);
    if (next) next.addEventListener('click', onNextClick);
    window.addEventListener('resize', update, { passive:true });
    root._pikeoCarouselRefresh = () => {
      requestAnimationFrame(update);
    };
    root._pikeoCarouselCleanup = () => {
      window.removeEventListener('resize', update);
      rail.removeEventListener('scroll', onScroll);
      rail.removeEventListener('scroll', onScrollForShine);
      if (supportsScrollEnd) rail.removeEventListener('scrollend', triggerShine);
      window.clearTimeout(scrollEndTimer);
      window.clearTimeout(shineTimer);
      if (prev) prev.removeEventListener('click', onPrevClick);
      if (next) next.removeEventListener('click', onNextClick);
      if (typeof rail._pikeoDragCleanup === 'function') {
        rail._pikeoDragCleanup();
      }
      rail.scrollLeft = 0;
    };
    requestAnimationFrame(update);
  };
  const refreshSearchDrawerCarousel = (drawer, reason = 'refresh') => {
    if (!drawer) return;
    drawer.querySelectorAll('[data-products-carousel]').forEach((root) => {
      const rail = root.querySelector('[data-products-rail]');
      const prev = root.querySelector('[data-products-prev]');
      const next = root.querySelector('[data-products-next]');
      if (!rail) return;
      const mode = root.dataset.productsCarouselMode || 'loop';
      if (mode === 'finite' || isMobileViewport()) {
        setupFiniteRail({ root, rail, prev, next });
      } else if (reason === 'breakpoint-change') {
        cleanupLoopingRail(root, rail, 'productLoopReady');
        setupLoopingRail({
          root,
          rail,
          itemSelector: root.dataset.loopItemSelector || '.prod',
          prevSelector: '[data-products-prev]',
          nextSelector: '[data-products-next]',
          readyFlag: 'productLoopReady'
        });
      } else if (typeof root._pikeoCarouselRefresh === 'function') {
        root._pikeoCarouselRefresh();
      }
    });
  };
  /* Helper de formato de contador final. Compartido por setupInfiniteRail
     y por los clones que pueda generar un carrusel en modo loop. Debe
     definirse antes de cualquier llamada. */
  const finalCountText = (el) => {
    const target = parseFloat(el.dataset.count || '0');
    const decimals = parseInt(el.dataset.decimals || '0', 10);
    const suffix = el.dataset.suffix || '';
    return (decimals ? (target / Math.pow(10, decimals)).toFixed(decimals) : Math.round(target).toLocaleString('es-CL')) + suffix;
  };

  /* Loop infinito reusable solo para carruseles que declaren ese modo.
     En móvil, los carruseles swipeables del landing usan riel finito. */
  const setupInfiniteRail = ({ rail, itemSelector, activeClass }) => {
    if (!rail || rail.dataset.infiniteReady === 'true') return;
    const originals = Array.from(rail.querySelectorAll(`${itemSelector}:not([data-loop-clone])`));
    if (!originals.length) return;
    rail.dataset.infiniteReady = 'true';

    originals.forEach((item, index) => {
      item.dataset.loopIndex = String(index);
      item.tabIndex = 0;
    });
    const clone = (item) => {
      const copy = item.cloneNode(true);
      copy.dataset.loopIndex = item.dataset.loopIndex;
      copy.dataset.loopClone = 'true';
      copy.setAttribute('aria-hidden', 'true');
      copy.classList.remove('reveal', 'in', 'd1', 'd2', 'd3');
      copy.querySelectorAll('.reveal,.in,.d1,.d2,.d3').forEach((el) => el.classList.remove('reveal', 'in', 'd1', 'd2', 'd3'));
      copy.querySelectorAll('.num[data-count]').forEach((num) => {
        num.textContent = finalCountText(num);
        num.removeAttribute('data-count');
      });
      return copy;
    };
    const before = originals.map(clone);
    const after = originals.map(clone);
    rail.prepend(...before);
    rail.append(...after);

    let allItems = Array.from(rail.querySelectorAll(itemSelector));
    let segment = 0;
    let ticking = false;
    let activeItem = originals[0];
    let pointerDown = false;

    const measure = () => {
      const firstReal = originals[0];
      const firstAfter = after[0];
      segment = firstReal && firstAfter ? firstAfter.offsetLeft - firstReal.offsetLeft : 0;
    };
    const setActiveItem = (item) => {
      if (!item || item === activeItem) return;
      allItems.forEach((node) => node.classList.remove(activeClass));
      item.classList.add(activeClass);
      activeItem = item;
    };
    const nearestItem = () => {
      const center = rail.scrollLeft + rail.clientWidth / 2;
      let closest = allItems[0];
      let distance = Infinity;
      allItems.forEach((item) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const nextDistance = Math.abs(itemCenter - center);
        if (nextDistance < distance) {
          closest = item;
          distance = nextDistance;
        }
      });
      return closest;
    };
    const normalize = () => {
      if (!segment) return;
      while (rail.scrollLeft < segment * .45) rail.scrollLeft += segment;
      while (rail.scrollLeft > segment * 1.55) rail.scrollLeft -= segment;
    };
    const update = () => {
      ticking = false;
      if (!pointerDown) normalize();
      setActiveItem(nearestItem());
    };
    const schedule = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    const centerRealSet = () => {
      measure();
      if (segment) rail.scrollLeft = segment;
      allItems.forEach((node) => node.classList.remove(activeClass));
      activeItem = originals[0];
      activeItem.classList.add(activeClass);
    };

    allItems.forEach((item) => {
      item.addEventListener('click', () => setActiveItem(item));
      item.addEventListener('mouseenter', () => setActiveItem(item));
      item.addEventListener('focusin', () => setActiveItem(item));
    });
    enableDragScroll(rail);
    rail.addEventListener('pointerdown', () => { pointerDown = true; }, { passive:true });
    const releasePointer = () => {
      pointerDown = false;
      schedule();
    };
    rail.addEventListener('pointerup', releasePointer, { passive:true });
    rail.addEventListener('pointercancel', releasePointer, { passive:true });
    rail.addEventListener('lostpointercapture', releasePointer, { passive:true });
    rail.addEventListener('scroll', schedule, { passive:true });
    window.addEventListener('resize', () => {
      allItems = Array.from(rail.querySelectorAll(itemSelector));
      centerRealSet();
    }, { passive:true });
    requestAnimationFrame(centerRealSet);
  };

  const initProductCarousels = () => {
    document.querySelectorAll('[data-products-carousel]').forEach((root) => {
      const rail = root.querySelector('[data-products-rail]');
      const prev = root.querySelector('[data-products-prev]');
      const next = root.querySelector('[data-products-next]');
      const itemSelector = root.dataset.loopItemSelector || '.prod';
      const hint = root.parentElement?.querySelector('.pikeo-swipe-hint');
      if (!rail) return;
      if (root.dataset.productsInitReady === 'true') {
        if (typeof root._pikeoCarouselRefresh === 'function') root._pikeoCarouselRefresh();
        return;
      }
      root.dataset.productsInitReady = 'true';
      const mode = root.dataset.productsCarouselMode || 'loop';
      const useFiniteRail = mode === 'finite' || isMobileViewport();
      if (useFiniteRail) {
        setupFiniteRail({ root, rail, prev, next });
      } else {
        setupLoopingRail({
          root,
          rail,
          itemSelector,
          prevSelector: '[data-products-prev]',
          nextSelector: '[data-products-next]',
          readyFlag: 'productLoopReady'
        });
      }
      const update = () => {
        if (useFiniteRail && typeof root._pikeoCarouselRefresh === 'function') {
          root._pikeoCarouselRefresh();
          return;
        }
        const hasOverflow = rail.scrollWidth - rail.clientWidth > 12;
        root.classList.toggle('is-static', !hasOverflow);
        if (prev) prev.disabled = !hasOverflow;
        if (next) next.disabled = !hasOverflow;
      };
      if (hint && hint.dataset.swipeHintReady !== 'true') {
        hint.dataset.swipeHintReady = 'true';
        window.setTimeout(() => {
          hint.classList.add('is-dimmed');
        }, 5200);
      }
      window.addEventListener('resize', update, { passive:true });
      update();
    });
  };
  const setupTestimonialViewportPlayback = (root) => {
    if (!root || root.dataset.testimonialViewportReady === 'true') return;
    root.dataset.testimonialViewportReady = 'true';
    const autoplayEnabled = root.dataset.testimonialAutoplay !== 'false';
    const videos = Array.from(root.querySelectorAll('[data-testimonial-video]'));
    if (!videos.length) return;

    const setPlayback = (video, shouldPlay) => {
      if (!video) return;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.autoplay = autoplayEnabled;
      if (shouldPlay) {
        const maybePromise = video.play();
        if (maybePromise && typeof maybePromise.catch === 'function') maybePromise.catch(() => {});
      } else {
        video.pause();
      }
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        const shouldPlay = autoplayEnabled && entry.isIntersecting && entry.intersectionRatio >= 0.45;
        setPlayback(video, shouldPlay);
      });
    }, {
      threshold: [0, 0.2, 0.45, 0.7, 1],
      root: null,
      rootMargin: '140px 0px 140px 0px'
    });

    videos.forEach((video) => observer.observe(video));

    const pauseAll = () => videos.forEach((video) => setPlayback(video, false));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pauseAll();
    }, { passive:true });
    root.addEventListener('mouseleave', () => {
      if (window.matchMedia('(hover:hover) and (pointer:fine)').matches === false) return;
      // no-op on desktop leave to avoid flicker; IntersectionObserver resumes naturally
    }, { passive:true });
  };
  const initVideoTestimonialCarousels = () => {
    document.querySelectorAll('[data-video-testimonials]').forEach((root) => {
      setupTestimonialViewportPlayback(root);
    });
  };

  /* Shine de los botones .pk-add-btn al entrar la sección en viewport (mobile).
     Estas secciones (individual-productos, vitrina-coleccion) usan grilla fija
     sin swipe, así que el disparo es por scroll-into-view en vez de scrollend.
     Dispara una vez por entrada: añade .is-shine a todos los botones visibles
     y la retira a los 720ms (duración de la animación). */
  const setupProductCardShine = (sectionEl) => {
    if (!sectionEl || sectionEl.dataset.pkiShineReady === 'true') return;
    const buttons = sectionEl.querySelectorAll('.pk-add-btn');
    if (!buttons.length) return;
    sectionEl.dataset.pkiShineReady = 'true';
    const trigger = () => {
      buttons.forEach((btn) => {
        btn.classList.remove('is-shine');
        void btn.offsetWidth; /* reflow para reiniciar la animación */
        btn.classList.add('is-shine');
        window.setTimeout(() => btn.classList.remove('is-shine'), 720);
      });
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.4) trigger();
      });
    }, {
      threshold: [0, 0.4, 0.7],
      rootMargin: '0px 0px -10% 0px'
    });
    observer.observe(sectionEl);
    sectionEl._pkiShineObserver = observer;
  };
  const initProductCardShine = () => {
    document.querySelectorAll('.pk-individual-products, .pk-vitrine-item').forEach((sectionEl) => {
      setupProductCardShine(sectionEl);
    });
  };

  const onScroll = () => {
    const compact = window.scrollY > 12;
    if (nav) nav.classList.toggle('scrolled', compact);
    document.body.classList.toggle('nav-compressed', compact);
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (progress) progress.style.width = (max > 0 ? (window.scrollY / max) * 100 : 0) + '%';
  };
  onScroll(); window.addEventListener('scroll', onScroll, { passive:true });

  /* Hero 3.7: envase que carga, boom y explosión de ingredientes controlada por swipe */
  (() => {
    const stage = document.querySelector('[data-burst-hero]');
    if (!stage) return;
    const hero = stage.closest('.hero');
    if (!hero) return;
    const packA = stage.querySelector('.pack-float.p-a');
    const packB = stage.querySelector('.pack-float.p-b');
    const packC = stage.querySelector('.pack-float.p-c');
    const packD = stage.querySelector('.pack-float.p-d');
    const boom = stage.querySelector('.boom-sabor');
    const bits = Array.from(stage.querySelectorAll('.bulk-bit'));
    const ingredients = Array.from(stage.querySelectorAll('.ingredient'));
    const clamp = (n, min = 0, max = 1) => Math.min(max, Math.max(min, n));
    const smooth = (n) => {
      const x = clamp(n);
      return x * x * (3 - 2 * x);
    };
    const cssNum = (el, name, fallback = 0) => {
      const value = getComputedStyle(el).getPropertyValue(name).trim();
      const parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };
    let bitData = [];
    let ingredientData = [];
    const readMotionData = () => {
      bitData = bits.map((el) => ({
        el,
        dx: cssNum(el, '--dx'),
        dy: cssNum(el, '--dy'),
        r: cssNum(el, '--r'),
        spin: cssNum(el, '--spin')
      }));
      ingredientData = ingredients.map((el) => ({
        el,
        dx: cssNum(el, '--dx'),
        dy: cssNum(el, '--dy'),
        r: cssNum(el, '--r'),
        spin: cssNum(el, '--spin')
      }));
    };
    const setBurst = (raw) => {
      const p = clamp(raw);
      const charge = smooth(p / .14);
      const blast = smooth((p - .16) / .16);
      const packOut = smooth((p - .30) / .24);
      const sideOut = smooth((p - .34) / .26);
      const bulkIn = smooth((p - .12) / .22);
      const lateFade = 1 - smooth((p - .88) / .12);
      const bitOut = smooth((p - .18) / .56);
      const crumbs = bitOut * lateFade;
      const ingredientOut = smooth((p - .18) / .60);
      const inflateWindow = clamp((p - .01) / .20);
      const inflate = Math.sin(inflateWindow * Math.PI) * .22 + blast * .10;
      const packZoom = charge * (1 - smooth((p - .34) / .20)) * .20;
      const packPop = Math.sin(clamp((p - .11) / .18) * Math.PI) * .24;
      const shockWindow = clamp((p - .14) / .26);
      const firstShock = Math.sin(shockWindow * Math.PI);
      const lateShock = smooth((p - .68) / .22) * (1 - smooth((p - .93) / .07));
      const shock = Math.max(firstShock, lateShock);
      const boomIn = smooth((p - .18) / .12);
      const boomOut = 1 - smooth((p - .82) / .16);
      const boomOpacity = boomIn * boomOut;
      const boomScale = .34 + smooth((p - .18) / .16) * .90 + smooth((p - .44) / .34) * .34;
      const boomY = 24 - p * 54;

      stage.style.setProperty('--burst', p.toFixed(3));
      stage.style.setProperty('--inflate', inflate.toFixed(3));
      stage.style.setProperty('--pack-zoom', packZoom.toFixed(3));
      stage.style.setProperty('--pack-pop', packPop.toFixed(3));
      stage.style.setProperty('--ingredient-out', ingredientOut.toFixed(3));
      stage.style.setProperty('--pack-opacity', Math.max(0, 1 - packOut).toFixed(3));
      stage.style.setProperty('--side-pack-opacity', Math.max(0, 1 - sideOut).toFixed(3));
      stage.style.setProperty('--bulk-opacity', (bulkIn * lateFade).toFixed(3));
      stage.style.setProperty('--bulk-scale', (.62 + bulkIn * .42 + shock * .05).toFixed(3));
      stage.style.setProperty('--shock-opacity', (shock * .72).toFixed(3));
      stage.style.setProperty('--shock-scale', (.58 + p * 1.22).toFixed(3));
      stage.style.setProperty('--crumb-opacity', crumbs.toFixed(3));
      stage.style.setProperty('--boom-opacity', boomOpacity.toFixed(3));
      stage.style.setProperty('--boom-scale', boomScale.toFixed(3));
      stage.style.setProperty('--boom-y', `${boomY.toFixed(1)}px`);

      if (packA) {
        packA.style.opacity = Math.max(0, 1 - packOut).toFixed(3);
        packA.style.transform = `translate(-50%,-50%) rotate(${(-7 - p * 10).toFixed(2)}deg) scale(${(1 + packZoom + packPop + inflate * .24).toFixed(3)})`;
      }
      if (packB) {
        packB.style.opacity = Math.max(0, 1 - sideOut).toFixed(3);
        packB.style.transform = `translate(-50%,-50%) translate(${(p * 58).toFixed(1)}px,${(p * -22).toFixed(1)}px) rotate(${(8 + p * 13).toFixed(2)}deg) scale(${(.92 + packZoom * .85 + packPop * .55 - p * .08).toFixed(3)})`;
      }
      if (packC) {
        packC.style.opacity = Math.max(0, 1 - sideOut).toFixed(3);
        packC.style.transform = `translate(-50%,-50%) translate(${(p * 78).toFixed(1)}px,${(p * -34).toFixed(1)}px) rotate(${(-13 + p * 17).toFixed(2)}deg) scale(${(.82 + packZoom * .70 - p * .10).toFixed(3)})`;
      }
      if (packD) {
        packD.style.opacity = Math.max(0, 1 - sideOut).toFixed(3);
        packD.style.transform = `translate(-50%,-50%) translate(${(p * -70).toFixed(1)}px,${(p * 28).toFixed(1)}px) rotate(${(10 - p * 15).toFixed(2)}deg) scale(${(.78 + packZoom * .65 - p * .08).toFixed(3)})`;
      }
      if (boom) boom.style.transform = `translate(-50%,-50%) translateY(${boomY.toFixed(1)}px) scale(${boomScale.toFixed(3)}) rotate(${(-4 + p * 7).toFixed(2)}deg)`;
      bitData.forEach(({ el, dx, dy, r, spin }) => {
        el.style.transform = `translate(-50%,-50%) translate(${(bitOut * dx).toFixed(1)}px,${(bitOut * dy).toFixed(1)}px) rotate(${(r + bitOut * spin).toFixed(2)}deg) scale(${(.58 + bitOut * .86).toFixed(3)})`;
      });
      ingredientData.forEach(({ el, dx, dy, r, spin }) => {
        el.style.transform = `translate(-50%,-50%) translate(${(ingredientOut * dx).toFixed(1)}px,${(ingredientOut * dy).toFixed(1)}px) rotate(${(r + ingredientOut * spin).toFixed(2)}deg) scale(${(1 + ingredientOut * .54).toFixed(3)})`;
      });
    };

    readMotionData();
    const boomTravelFactor = () => {
      const speed = responsiveAttr(stage, 'data-boom-speed', 'data-boom-speed-mobile', 'normal');
      return ({ slow: 1.35, normal: 1, fast: 0.72 })[speed] || 1;
    };
    const boomMode = () => responsiveAttr(stage, 'data-boom', 'data-boom-mobile', 'on');
    const numberAttr = (el, name, fallback) => {
      const value = parseFloat(el?.getAttribute(name) || '');
      return Number.isFinite(value) ? value : fallback;
    };
    const getDesktopBurstProgress = () => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const heroTop = hero.getBoundingClientRect().top + window.scrollY;
      const speedFactor = boomTravelFactor();
      const startOffset = vh * (numberAttr(stage, 'data-boom-start', 0) / 100);
      const travelPercent = numberAttr(stage, 'data-boom-travel', 70) / 100;
      const maxProgress = clamp(numberAttr(stage, 'data-boom-max', 100) / 100, .70, 1);
      const baseTravel = vh * Math.max(.30, travelPercent);
      const travel = baseTravel * Math.max(.72, speedFactor);
      const startAt = heroTop + startOffset;
      const endAt = startAt + travel;
      return clamp((window.scrollY - startAt) / Math.max(1, endAt - startAt)) * maxProgress;
    };
    const getMobileBurstProgress = () => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const rect = hero.getBoundingClientRect();
      const heroHeight = Math.max(hero.offsetHeight || 0, rect.height || 0, vh);
      const speedFactor = boomTravelFactor();
      const startOffset = vh * (numberAttr(stage, 'data-boom-mobile-start', 10) / 100);
      const extraTravel = vh * (numberAttr(stage, 'data-boom-mobile-travel', 70) / 100);
      const maxProgress = clamp(numberAttr(stage, 'data-boom-mobile-max', 94) / 100, .60, 1);
      const travel = (heroHeight * 1.08 + extraTravel) * Math.max(1, speedFactor * .98);
      const raw = (startOffset - rect.top) / Math.max(1, travel);
      const eased = clamp(raw);
      return eased * maxProgress;
    };

    let ticking = false;
    const updateBurst = () => {
      const mode = boomMode();
      if (mode === 'off') { setBurst(0); return; }          /* estático, packs ensamblados */
      if (reduceMotion || mode === 'static') {
        setBurst(.74);                                       /* congelado en plena explosión */
        return;
      }
      if (isMobileViewport()) {
        setBurst(getMobileBurstProgress());
        return;
      }
      setBurst(getDesktopBurstProgress());
    };
    const scheduleBurst = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        updateBurst();
      });
    };
    updateBurst();
    window.addEventListener('scroll', scheduleBurst, { passive:true });
    window.addEventListener('resize', () => {
      readMotionData();
      scheduleBurst();
    }, { passive:true });
  })();

  /* Menú móvil */
  const mm = document.getElementById('mobileMenu');
  const bd = document.getElementById('backdrop');
  const burger = document.getElementById('burger');
  const mmClose = document.getElementById('mmClose');
  const inlineMenus = Array.from(document.querySelectorAll('.pikeo-menu-inline'));
  const headerDropdowns = Array.from(document.querySelectorAll('.nav-dropdown'));
  const closeInlineMenus = () => {
    inlineMenus.forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelectorAll('details[open]').forEach((submenu) => submenu.removeAttribute('open'));
    });
  };
  const closeHeaderDropdowns = () => {
    headerDropdowns.forEach((menu) => menu.removeAttribute('open'));
  };
  const openMenu = (o) => {
    if (!mm || !bd) return;
    mm.classList.toggle('open', o);
    bd.classList.toggle('show', o);
    mm.setAttribute('aria-hidden', String(!o));
    document.body.style.overflow = o ? 'hidden' : '';
    if (!o) closeInlineMenus();
  };
  if (mm && bd && burger && mmClose) {
    burger.addEventListener('click', () => openMenu(true));
    mmClose.addEventListener('click', () => openMenu(false));
    bd.addEventListener('click', () => openMenu(false));
    mm.querySelectorAll('a').forEach(a => a.addEventListener('click', () => openMenu(false)));
    document.addEventListener('pointerdown', (event) => {
      if (!inlineMenus.some((menu) => menu.hasAttribute('open'))) return;
      if (event.target.closest('.pikeo-menu-inline')) return;
      closeInlineMenus();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeInlineMenus();
        closeHeaderDropdowns();
        openMenu(false);
      }
    });
  }
  document.addEventListener('pointerdown', (event) => {
    if (!headerDropdowns.some((menu) => menu.hasAttribute('open'))) return;
    if (event.target.closest('.nav-dropdown')) return;
    closeHeaderDropdowns();
  });
  window.addEventListener('scroll', () => {
    closeInlineMenus();
    closeHeaderDropdowns();
  }, { passive:true });
  window.addEventListener('resize', () => {
    closeInlineMenus();
    closeHeaderDropdowns();
  }, { passive:true });
  document.addEventListener('pikeo:search-promotion:hydrated', () => {
    initProductCarousels();
  });
  document.addEventListener('pikeo:search-drawer:refresh', (event) => {
    const reason = event.detail?.reason;
    refreshSearchDrawerCarousel(event.detail?.drawer, reason);
    if (reason !== 'resize' && reason !== 'breakpoint-change' && reason !== 'media-change') {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
  });
  initProductCarousels();
  initVideoTestimonialCarousels();
  initProductCardShine();

  const carouselBreakpoint = window.matchMedia('(max-width: 767px)');
  const rehydrateProductCarouselsForBreakpoint = () => {
    document.querySelectorAll('[data-products-carousel]').forEach((root) => {
      const rail = root.querySelector('[data-products-rail]');
      cleanupLoopingRail(root, rail, 'productLoopReady');
      delete root.dataset.productsInitReady;
    });
    initProductCarousels();
  };
  if (carouselBreakpoint.addEventListener) {
    carouselBreakpoint.addEventListener('change', rehydrateProductCarouselsForBreakpoint);
  } else if (carouselBreakpoint.addListener) {
    carouselBreakpoint.addListener(rehydrateProductCarouselsForBreakpoint);
  }

 /* WhatsApp floating button: mensajes secuenciales */
(() => {
  const root = document.getElementById('wa-float-pikeo');
  if (!root) return;

  const msgs = root.querySelectorAll('.wa-msg[data-seq]');
  if (!msgs.length) return;

  const toInt = (value, fallback) => {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const autoplay = root.dataset.waMessageAutoplay !== 'false';
  const maxViews = Math.max(0, toInt(root.dataset.waMessageLimit, 1));
  const windowHours = Math.max(1, toInt(root.dataset.waMessageWindowHours, 168));
  const storageKey = 'pikeo-wa-message:' + (root.dataset.waStorageKey || 'pikeo-whatsapp-v1');

  if (!autoplay || maxViews === 0) return;

  const now = Date.now();
  const windowMs = windowHours * 60 * 60 * 1000;

  const readState = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '{}') || {};
    } catch (_) {
      return {};
    }
  };

  const saveState = (state) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (_) {}
  };

  let state = readState();
  if (!state.startedAt || now - state.startedAt > windowMs) {
    state = { count: 0, startedAt: now };
  }

  if ((state.count || 0) >= maxViews) return;

  const markShown = () => {
    state.count = (state.count || 0) + 1;
    state.startedAt = state.startedAt || now;
    saveState(state);
  };

  const startDelay = 4500;
  const gap = 700;
  const hideDelay = 6000;
  const repeat = false;
  const repeatGap = 12000;
  let i = 0;

  const reset = () => {
    i = 0;
    msgs.forEach((m) => m.classList.remove('wa-msg--show', 'wa-msg--hide'));
  };

  const hideAll = () => {
    msgs.forEach((m) => m.classList.add('wa-msg--hide'));
    setTimeout(() => {
      msgs.forEach((m) => m.classList.remove('wa-msg--show', 'wa-msg--hide'));
      if (repeat) setTimeout(run, repeatGap);
    }, 450);
  };

  const showNext = () => {
    if (i < msgs.length) {
      msgs[i].classList.add('wa-msg--show');
      i += 1;
      setTimeout(showNext, gap);
    } else {
      setTimeout(hideAll, hideDelay);
    }
  };

  function run() {
    markShown();
    reset();
    setTimeout(showNext, startDelay);
  }

  run();
})();

  /* Desktop 3.14 + swipe finito nativo en móvil */
  (() => {
    /* finalCountText y setupInfiniteRail viven en el scope superior.
       Aquí solo queda setupStaticRail + la inicialización de
       Manifiesto/Métricas como rieles nativos. */

    const setupStaticRail = ({ rail, itemSelector, activeClass }) => {
      if (!rail || rail.dataset.staticReady === 'true') return;
      const items = Array.from(rail.querySelectorAll(itemSelector));
      if (!items.length) return;
      rail.dataset.staticReady = 'true';
      const setActive = (item) => {
        items.forEach((node) => node.classList.toggle(activeClass, node === item));
      };
      items.forEach((item, index) => {
        item.tabIndex = 0;
        item.addEventListener('click', () => setActive(item));
        item.addEventListener('mouseenter', () => setActive(item));
        item.addEventListener('focusin', () => setActive(item));
        if (index === 0) item.classList.add(activeClass);
      });
    };

    const manifestoRail = document.querySelector('[data-manifesto-rail]');
    const metricRail = document.querySelector('[data-metrics-strip] .metric-grid');
    setupStaticRail({
      rail:manifestoRail,
      itemSelector:'.manifesto-card',
      activeClass:'is-active'
    });
    setupStaticRail({
      rail:metricRail,
      itemSelector:'[data-metric-card]',
      activeClass:'is-hot'
    });
    /* En móvil dejamos Manifiesto/Métricas como swipe finito nativo:
       se muestra la cantidad real de tarjetas y el scroll vertical no se bloquea. */
  })();

  /* FAQ suave */
  const closeFaq = (item) => {
    item.classList.remove('is-open');
    item.dataset.closing = 'true';
    window.setTimeout(() => {
      item.removeAttribute('open');
      delete item.dataset.closing;
    }, reduceMotion ? 0 : 480);
  };
  document.querySelectorAll('.faq').forEach((item) => {
    const summary = item.querySelector('summary');
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (item.dataset.closing === 'true') return;
      const isOpen = item.hasAttribute('open') && item.classList.contains('is-open');
      document.querySelectorAll('.faq[open]').forEach((other) => { if (other !== item) closeFaq(other); });
      if (isOpen) { closeFaq(item); return; }
      item.setAttribute('open', '');
      requestAnimationFrame(() => item.classList.add('is-open'));
    });
  });

  /* Reveal on scroll */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold:0.14, rootMargin:'0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  /* Drama interactivo */
  const painCards = document.querySelectorAll('[data-pain]');
  if (painCards.length) {
    const painObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('active', entry.isIntersecting);
      });
    }, { threshold:0.58, rootMargin:'-12% 0px -18% 0px' });
    painCards.forEach((card) => painObs.observe(card));
  }

  /* Beneficios interactivos */
  const benefitCards = document.querySelectorAll('[data-benefit]');
  if (benefitCards.length) {
    const benefitObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('active', entry.isIntersecting);
      });
    }, { threshold:0.52, rootMargin:'-10% 0px -18% 0px' });
    benefitCards.forEach((card) => benefitObs.observe(card));
  }

  /* Galería de beneficios guiada por el swipe */
  const swipeGallery = document.querySelector('[data-swipe-gallery]');
  const sceneSlides = swipeGallery ? Array.from(swipeGallery.querySelectorAll('[data-scene]')) : [];
  if (swipeGallery && sceneSlides.length) {
    const solutionSection = swipeGallery.closest('.solution');
    const solutionShell = swipeGallery.closest('.solution-shell') || solutionSection;
    const galleryCards = Array.from(document.querySelectorAll('[data-benefit]'));
    const clamp = (n, min = 0, max = 1) => Math.min(max, Math.max(min, n));
    const hexToRgb = (hex) => {
      const value = hex.replace('#','');
      return [0,2,4].map((i) => parseInt(value.slice(i, i + 2), 16));
    };
    const mixHex = (a, b, t) => {
      const ar = hexToRgb(a), br = hexToRgb(b);
      const rgb = ar.map((v, i) => Math.round(v + (br[i] - v) * t));
      return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
    };
    const readColor = (slide, name, fallback) => slide.getAttribute(`data-${name}`) || fallback;
    const paintGallery = () => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const firstCard = galleryCards[0];
      const lastCard = galleryCards[galleryCards.length - 1];
      const shellTop = solutionShell.getBoundingClientRect().top + window.scrollY;
      const firstTop = firstCard ? firstCard.getBoundingClientRect().top + window.scrollY : shellTop;
      const lastTop = lastCard ? lastCard.getBoundingClientRect().top + window.scrollY : shellTop + vh;
      const startAt = firstTop - vh * .92;
      const endAt = lastTop - vh * .28;
      const galleryMode = responsiveAttr(swipeGallery, 'data-gallery-mode', 'data-gallery-mode-mobile', 'on');
      const gallerySpeed = responsiveAttr(swipeGallery, 'data-gallery-speed', 'data-gallery-speed-mobile', 'normal');
      const galleryFactor = ({ slow: 1.35, normal: 1, fast: 0.72 })[gallerySpeed] || 1;
      const progressValue = galleryMode === 'off'
        ? 0
        : clamp((window.scrollY - startAt) / Math.max(1, (endAt - startAt) * .62 * galleryFactor));
      const raw = progressValue * (sceneSlides.length - 1);
      const activeIndex = Math.min(sceneSlides.length - 1, Math.floor(raw + .0001));
      const activeSlide = sceneSlides[activeIndex];
      const local = activeIndex === sceneSlides.length - 1 ? 1 : clamp(raw - activeIndex);
      const easedZoom = 1 - Math.pow(1 - local, 3);
      const popPulse = Math.sin(local * Math.PI) * .06;
      const entryScale = .7 + easedZoom * .34 + popPulse;
      const aura = .84 + easedZoom * .28;

      const bg = swipeGallery.getAttribute('data-scene-bg-override') || readColor(activeSlide, 'bg', '#f7d36b');
      const bg2 = readColor(activeSlide, 'bg-2', '#fff8df');
      const accent = swipeGallery.getAttribute('data-scene-accent-override') || readColor(activeSlide, 'accent', '#e7a81b');
      const ink = swipeGallery.getAttribute('data-scene-ink-override') || readColor(activeSlide, 'ink', '#2746dc');
      [swipeGallery, solutionSection].forEach((target) => {
        if (!target) return;
        target.style.setProperty('--scene-bg', bg);
        target.style.setProperty('--scene-bg-2', bg2);
        target.style.setProperty('--scene-accent', accent);
        target.style.setProperty('--scene-ink', ink);
        target.style.setProperty('--gallery-progress', progressValue.toFixed(3));
      });

      sceneSlides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        const stageRect = swipeGallery.getBoundingClientRect();
        const art = slide.querySelector('.scene-art');
        const safeWidth = Math.max(220, Math.min(stageRect.width || window.innerWidth, window.innerWidth) - 32);
        const safeHeight = Math.max(220, Math.min(stageRect.height || vh, vh - 150));
        const artWidth = art ? art.offsetWidth : safeWidth;
        const artHeight = art ? art.offsetHeight : safeHeight;
        const fitScale = Math.min(1.08, Math.max(.78, Math.min(safeWidth / Math.max(1, artWidth), safeHeight / Math.max(1, artHeight))));
        slide.style.clipPath = 'none';
        slide.style.opacity = isActive ? '1' : '0';
        slide.style.zIndex = isActive ? '3' : '0';
        slide.style.transform = isActive ? `scale(${entryScale.toFixed(3)})` : 'scale(.7)';
        slide.style.setProperty('--fit-scale', fitScale.toFixed(3));
        slide.style.setProperty('--scene-aura', isActive ? aura.toFixed(3) : '.72');
        slide.classList.toggle('is-current', isActive);
        slide.classList.remove('is-next');
      });

      galleryCards.forEach((card, index) => {
        card.classList.toggle('active', index === activeIndex);
      });
    };
    let galleryTicking = false;
    const scheduleGallery = () => {
      if (galleryTicking) return;
      galleryTicking = true;
      requestAnimationFrame(() => {
        galleryTicking = false;
        paintGallery();
      });
    };
    paintGallery();
    window.addEventListener('scroll', scheduleGallery, { passive:true });
    window.addEventListener('resize', scheduleGallery, { passive:true });
  }

  /* Contadores */
  const animateCount = (el) => {
    const target = parseFloat(el.dataset.count), decimals = parseInt(el.dataset.decimals || '0',10), suffix = el.dataset.suffix || '';
    const fmt = (n) => (decimals ? (n/Math.pow(10,decimals)).toFixed(decimals) : Math.round(n).toLocaleString('es-CL')) + suffix;
    const strip = el.closest('[data-metrics-strip]');
    const mode = strip ? responsiveAttr(strip, 'data-count-mode', 'data-count-mode-mobile', 'normal') : 'normal';
    if (mode === 'off') { el.textContent = fmt(target); return; }   /* muestra el número final, sin conteo */
    const durMap = { slow: 2600, normal: 1500, fast: 700 };
    const dur = durMap[mode] || 1500, t0 = performance.now();
    const tick = (now) => { const p = Math.min((now-t0)/dur,1), eased = 1-Math.pow(1-p,3);
      el.textContent = fmt(target*eased); if (p<1) requestAnimationFrame(tick); else el.textContent = fmt(target); };
    requestAnimationFrame(tick);
  };
  const cio = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting){ animateCount(e.target); cio.unobserve(e.target); } });
  }, { threshold:0.5 });
  document.querySelectorAll('.num[data-count]').forEach(el => cio.observe(el));

  /* ============================================================
     EDITOR DE SHOPIFY — puente de re-render
     ============================================================
     En el sitio en vivo, este archivo se ejecuta una sola vez y el
     IntersectionObserver de arriba hace visibles los .reveal al hacer
     scroll. En el EDITOR, cada vez que se cambia un ajuste Shopify
     re-renderiza sólo la sección afectada dentro del iframe y NO
     vuelve a correr este JS. Sin este puente, los .reveal recién
     renderizados se quedan en opacity:0 (la sección "desaparece").
     La red de seguridad CSS (.pikeo-editor .reveal) ya los mantiene
     visibles siempre; aquí además re-aplicamos .in por si la regla no
     alcanza, reiniciamos carruseles y disparamos contadores dentro de
     la sección re-renderizada, para que se vea fiel al sitio en vivo.
     Fuera del editor (window.Shopify.designMode indefinido) todo esto
     queda inerte. */
  if (window.Shopify && window.Shopify.designMode) {
    /* Re-aplica .in y reinicia lo que depende del JS dentro de la
       sección que el editor acaba de (re)dibujar. */
    const hydrateSection = (sectionEl) => {
      if (!sectionEl || sectionEl.nodeType !== 1) return;
      /* Reveal: forzar visible de inmediato en el editor. */
      sectionEl.querySelectorAll('.reveal:not(.in)').forEach((el) => el.classList.add('in'));

      /* Carruseles: resetear banderas de "ya inicializado" para que
         initProductCarousels() los rearme con el DOM nuevo. */
      sectionEl.querySelectorAll('[data-products-carousel]').forEach((root) => {
        delete root.dataset.productsInitReady;
        delete root.dataset.productLoopReady;
        if (typeof root._pikeoCarouselCleanup === 'function') root._pikeoCarouselCleanup();
      });
      /* Testimonios en video: resetear bandera de playback. */
      sectionEl.querySelectorAll('[data-video-testimonials]').forEach((root) => {
        delete root.dataset.testimonialViewportReady;
      });
      /* Shine de botones .pk-add-btn: resetear para rearmar observer. */
      sectionEl.querySelectorAll('.pk-individual-products, .pk-vitrine-item').forEach((root) => {
        if (typeof root._pkiShineObserver?.disconnect === 'function') root._pkiShineObserver.disconnect();
        delete root.dataset.pkiShineReady;
      });
      initProductCarousels();
      initVideoTestimonialCarousels();
      initProductCardShine();

      /* Contadores: animar los que aún no corrieron. */
      sectionEl.querySelectorAll('.num[data-count]').forEach((el) => {
        if (!el.dataset.pikeoCounted) { el.dataset.pikeoCounted = '1'; animateCount(el); }
      });
    };

    /* Sección (re)cargada en el editor — evento principal al cambiar
       un ajuste o al añadir/mover una sección. event.target es el
       wrapper #shopify-section-<id> recién pintado. */
    document.addEventListener('shopify:section:load', (event) => hydrateSection(event.target));
    /* Sección seleccionada (clic en la lista de secciones del editor). */
    document.addEventListener('shopify:section:select', (event) => hydrateSection(event.target));
    /* Bloque seleccionado (clic en un bloque dentro de una sección). */
    document.addEventListener('shopify:block:select', (event) => hydrateSection(event.target));
  }
